/**
 * Voice and chat agent widgets are enabled on yandle.io (production) and on
 * localhost during dev so you can test without deploying.
 * @returns {boolean}
 */
export function isYandleAgentHostEnabled() {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname.toLowerCase()
  if (host === 'yandle.io' || host.endsWith('.yandle.io')) return true
  if (
    process.env.NODE_ENV === 'development' &&
    (host === 'localhost' || host === '127.0.0.1')
  ) {
    return true
  }
  return false
}
